import React from 'react';

import { Provider } from 'react-redux';
import { Route, Switch, Router } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import store from '../../store';
import appHistory from '../../appHistory';
import { common } from '../../data/constants';
import Home from '../../scenes/Home';
import Bidding from '../../scenes/BidSession';
import Reports from '../../scenes/Reports';
import History from '../../scenes/History/History';
import Settings from '../../scenes/Settings';
import Impersonate from '../../scenes/Impersonate';
import CrewGroupDefault from '../../scenes/CrewGroupDefault';
import DefaultSettings from '../../scenes/DefaultSettings';
import PastSession from '../../scenes/PastSession';
import { Error500 } from '../ErrorPages';
import MsalMainLayout from '../Layouts/MsalMainLayout';
import ReportLoader from '../../scenes/Reports/components/ReportLoader';

const customMUI = getMuiTheme({
  palette: {
    primary1Color: common.colors.CI_BLUE,
    primary2Color: common.colors.CI_BLUE,
    pickerHeaderColor: common.colors.CI_BLUE
  }
});

function Pages() {
  return (
    <Switch>
      <Route path="/report-loader/:uniqueIdentifier" component={ReportLoader} />
      <MsalMainLayout>
        <Route exact path="/home" component={Home} />
        <Route path="/bid-session/:bidId" component={Bidding} />
        <Route path="/reports" component={Reports} />
        <Route path="/history" component={History} />
        <Route path="/settings" component={Settings} />
        <Route path="/impersonate" component={Impersonate} />
        <Route path="/crew-group-default" component={CrewGroupDefault} />
        <Route
          path="/help"
          component={() => {
            const hostname = window.location.hostname;
            // eslint-disable-next-line eqeqeq
            // Added for checking localhost application url
            if (hostname !== 'localhost') {
              window.location.href = window.helpUrl;
            } else {
              window.location.href = '/assets/help/Content/Home.htm';
            }
            return null;
          }}
        />
        <Route path="/default-settings" component={DefaultSettings} />
        <Route path="/history/:sessionId" component={PastSession} />
        <Route path="/500" component={Error500} />
      </MsalMainLayout>
    </Switch>
  );
}

// Remember that MsalProvider must be rendered somewhere higher up in the component tree
function MsalApp({ msalInstance }) {
  return (
    <MuiThemeProvider muiTheme={customMUI}>
      <Provider store={store}>
        <Router history={appHistory}>
          <Pages />
        </Router>
      </Provider>
    </MuiThemeProvider>
  );
}

export default MsalApp;
